import { c as _c } from "react/compiler-runtime";
import { useAtom, useSetAtom } from "jotai";
import { useParams } from "next/navigation";
import { useEffect, useMemo } from "react";
import { currentLanguageAtom, languageStateAtom } from "@/store/languageAtom";
import { fallbackLng, getRegionLanguages, SUPPORTED_LANGUAGES } from "../settings";
import { getAreaFromLocale, getLanguageFromLocale } from "../utils";
export function useClientAreaLanguages() {
  const $ = _c(26);
  const params = useParams();
  const [languageState, setLanguageState] = useAtom(languageStateAtom);
  const setCurrentLanguage = useSetAtom(currentLanguageAtom);
  const currentLocale = params.locale as string;
  let t0;
  if ($[0] !== currentLocale) {
    t0 = getLanguageFromLocale(currentLocale);
    $[0] = currentLocale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentLanguageFromLocale = t0;
  let t1;
  if ($[2] !== currentLocale) {
    t1 = getAreaFromLocale(currentLocale);
    $[2] = currentLocale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentAreaFromLocale = t1;
  let t2;
  if ($[4] !== currentAreaFromLocale) {
    t2 = getRegionLanguages(currentAreaFromLocale);
    $[4] = currentAreaFromLocale;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const validLanguages = t2;
  let t3;
  let t4;
  if ($[6] !== currentAreaFromLocale || $[7] !== setLanguageState || $[8] !== validLanguages) {
    t3 = () => {
      setLanguageState({
        availableLanguages: validLanguages,
        currentArea: currentAreaFromLocale
      });
    };
    t4 = [validLanguages, currentAreaFromLocale, setLanguageState];
    $[6] = currentAreaFromLocale;
    $[7] = setLanguageState;
    $[8] = validLanguages;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[11] !== currentLanguageFromLocale || $[12] !== currentLocale || $[13] !== languageState.currentLanguage || $[14] !== setCurrentLanguage || $[15] !== validLanguages) {
    t5 = () => {
      const isRegionOnlyRoute = !currentLocale.includes("-");
      const isLanguageRegionRoute = currentLocale.includes("-");
      let preferredLanguage = languageState.currentLanguage;
      if (isRegionOnlyRoute) {
        preferredLanguage = validLanguages.length > 0 ? validLanguages[0] : fallbackLng;
      } else {
        if (isLanguageRegionRoute) {
          const normalizedCurrentFromURL = currentLanguageFromLocale.toLowerCase();
          const isInValidLanguages = validLanguages.includes(normalizedCurrentFromURL);
          const isInSupportedLanguages = SUPPORTED_LANGUAGES.includes(normalizedCurrentFromURL as any);
          if (isInValidLanguages && isInSupportedLanguages) {
            preferredLanguage = normalizedCurrentFromURL;
          } else {
            preferredLanguage = fallbackLng;
          }
        }
      }
      if (languageState.currentLanguage !== preferredLanguage) {
        setCurrentLanguage(preferredLanguage);
      }
    };
    t6 = [currentLanguageFromLocale, validLanguages, languageState.currentLanguage, setCurrentLanguage, currentLocale];
    $[11] = currentLanguageFromLocale;
    $[12] = currentLocale;
    $[13] = languageState.currentLanguage;
    $[14] = setCurrentLanguage;
    $[15] = validLanguages;
    $[16] = t5;
    $[17] = t6;
  } else {
    t5 = $[16];
    t6 = $[17];
  }
  useEffect(t5, t6);
  let t7;
  bb0: {
    const isRegionOnlyRoute_0 = !currentLocale.includes("-");
    const isLanguageRegionRoute_0 = currentLocale.includes("-");
    if (isRegionOnlyRoute_0) {
      t7 = validLanguages.length > 0 ? validLanguages[0] : fallbackLng;
      break bb0;
    } else {
      if (isLanguageRegionRoute_0) {
        let t8;
        if ($[18] !== currentLanguageFromLocale) {
          t8 = currentLanguageFromLocale.toLowerCase();
          $[18] = currentLanguageFromLocale;
          $[19] = t8;
        } else {
          t8 = $[19];
        }
        t7 = t8;
        break bb0;
      }
    }
    t7 = fallbackLng;
  }
  const displayLanguage = t7;
  const t8 = validLanguages.length > 0 ? validLanguages[0] : fallbackLng;
  let t9;
  if ($[20] !== currentAreaFromLocale || $[21] !== displayLanguage || $[22] !== languageState.currentLanguage || $[23] !== t8 || $[24] !== validLanguages) {
    t9 = {
      languages: validLanguages,
      defaultLanguage: t8,
      isLoading: false,
      error: null,
      areaData: null,
      currentLanguage: languageState.currentLanguage,
      displayLanguage,
      currentArea: currentAreaFromLocale,
      supportedLngs: validLanguages
    };
    $[20] = currentAreaFromLocale;
    $[21] = displayLanguage;
    $[22] = languageState.currentLanguage;
    $[23] = t8;
    $[24] = validLanguages;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}